var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getCookie } from '@ciceksepeti/cs-cookie';
import { Typography } from '@ciceksepeti/cs-typography';
import { Spinner } from '@ciceksepeti/cs-spinner';
import '@ciceksepeti/cs-spinner/styles.css';
import { Link } from '@ciceksepeti/cs-link';
import Cookies from '@constants/cookies';
import HomePageTypes from '@constants/home-page-types';
import { getPopularCategories } from '@services/popular-categories';
import styles from './styles.module.scss';
var PopularCategories = function () {
    var _a, _b;
    var _c = useState(), categories = _c[0], setCategories = _c[1];
    var _d = useState(true), isCategoriesLoading = _d[0], setIsCategoriesLoading = _d[1];
    var mainPageType = getCookie(Cookies.HOME_PAGE_TYPE) || "".concat(HomePageTypes.CS);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, filteredResponseItems, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, getPopularCategories({})];
                    case 1:
                        response = _b.sent();
                        filteredResponseItems = (_a = response === null || response === void 0 ? void 0 : response.items) === null || _a === void 0 ? void 0 : _a.filter(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.mainPageType) === null || _a === void 0 ? void 0 : _a.toString()) === mainPageType; });
                        setCategories({ items: filteredResponseItems });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsCategoriesLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [mainPageType]);
    return (_jsx("div", { className: styles.categoryWrapper, children: isCategoriesLoading ? (_jsx(Spinner, { size: 32, color: "green", className: "spinnerContainer" })) : ((_a = categories === null || categories === void 0 ? void 0 : categories.items) === null || _a === void 0 ? void 0 : _a.length) && categories.items.length > 0 ? (_jsxs(_Fragment, { children: [_jsx(Typography, { as: "h2", "data-mobile-variant": "h6", "data-variant": "h5", children: "Pop\u00FCler Kategoriler" }), _jsx("div", { className: styles.categoryLinkWrapper, children: (_b = categories === null || categories === void 0 ? void 0 : categories.items) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                        var id = _a.id, name = _a.name, link = _a.link;
                        return (_jsx(Link, { className: styles.categoryLink, href: link, children: _jsx("span", { className: styles.clampText, children: name }) }, "popular-categories-".concat(id)));
                    }) })] })) : null }));
};
export default PopularCategories;
